/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';


import moment from 'moment';
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import { FiMail } from "react-icons/fi";
import { GoMailRead } from "react-icons/go";
import { BiMessageEdit } from "react-icons/bi";
import { VscPass } from "react-icons/vsc";

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_bullets from "@amcharts/amcharts4/plugins/bullets";
import * as am4plugins_timeline from "@amcharts/amcharts4/plugins/timeline";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";



am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);



const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 18,
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient(to right, #bdbdbd, #bdbdbd)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
}));

const ColorlibStepIconRoot = styled('div')<{
    ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    // ...(ownerState.completed && {
    //     backgroundImage:
    //         'linear-gradient(to right, rgb(182, 244, 146), rgb(51, 139, 147))',
    // }),
}));

function ColorlibStepIcon(props: StepIconProps) {
    const { active, completed, className } = props;

    const icons: { [index: string]: React.ReactElement } = {
        1: <FiMail className='icon-timeline' />,
        2: <GoMailRead className='icon-timeline' />,
        3: <BiMessageEdit className='icon-timeline' />,
        4: <VscPass className='icon-timeline' />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

const TypeComplaintTimeLineChart = (props) => {

    const { sBA, data } = props

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                {
                    data.length > 0 ?
                        data.map((element, index) => {
                            let sIndx = "key_timeline" + index
                            return (
                                <Grid key={sIndx} item xs={12} sm={6} md={4}>
                                    <div id={`timeline_${element.sID}`}>
                                        <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                                <Typography>{element.sTitle}</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Stepper alternativeLabel activeStep={4} connector={<ColorlibConnector />}>
                                                    {(element.lstdata).map((itm, ind) => (
                                                        <Step key={`st-${itm.text}`}>
                                                            <StepLabel
                                                                StepIconComponent={ColorlibStepIcon}
                                                                StepIconProps={{
                                                                    className: ind === 0 ? "timeline1" : ind === 1 ? "timeline2" : ind === 2 ? "timeline3" : "timeline4",
                                                                }}
                                                            >
                                                                {itm.start}
                                                                <br />
                                                                {itm.text}
                                                            </StepLabel>
                                                        </Step>
                                                    ))}
                                                </Stepper>
                                            </Grid>
                                        </Grid>
                                    </div>

                                </Grid>
                            )
                        })
                        : null
                }
            </Grid>
        </>
    )
}

export default TypeComplaintTimeLineChart